const swiper = new Swiper('#h-prodslider', {
  // Default parameters
  slidesPerView: 4,
  loop: true,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  } 
  });


jQuery("div#tab2").hide();
jQuery("a.tabbtn.t2").click(function(){
    jQuery(this).removeClass("active"); 
    jQuery("a.tabbtn.t1").removeClass("active"); 
    jQuery(this).addClass("active");
    jQuery("div#tab1").hide();
    jQuery("div#tab2").show();
});

jQuery("a.tabbtn.t1").click(function(){
    jQuery(this).removeClass("active"); 
    jQuery("a.tabbtn.t2").removeClass("active"); 
    jQuery(this).addClass("active");
    jQuery("div#tab2").hide();
    jQuery("div#tab1").show();
});